module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_6.abc70d5a.pdf";